export default __webpack_public_path__ + "static/media/service1.61fa28af.png";